import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'redux-form';
import { FormGroupField } from 'components/Form';
import { dictionaryColumnType } from 'types';
import ALPHABET from 'constants/alphabet';

import './style.scss';

const ColumnField = ({ fields }) => (
  <div styleName="fields">
    <div styleName="row">
      <div styleName="name">
        <span styleName="letter">{ALPHABET[0]}:</span>
        <span>Token</span>
      </div>
      <Field name="token" component={FormGroupField} disabled />
    </div>
    {fields.map(field => (
      <div styleName="row" key={field.id}>
        <div styleName="name">
          <span styleName="letter">{ALPHABET[field.order + 1]}:</span>
          <span>{field.name}</span>
        </div>
        <Field name={`values.${field.id}`} component={FormGroupField} />
      </div>
    ))}
  </div>
);

ColumnField.propTypes = {
  fields: PropTypes.arrayOf(dictionaryColumnType),
};

export default ColumnField;
